import SolutionHeroI18n from "@/components/landing/shared/SolutionHeroI18n";
import { ShoppingCart, Search, Package, CreditCard, Sparkles, TrendingUp } from "lucide-react";
import heroImage from "@/assets/hero-person-ecommerce.png";

const EcommerceHero = () => (
  <SolutionHeroI18n
    translationPrefix="ecommerceSolution"
    heroImage={heroImage}
    floatingIcons={[
      { icon: ShoppingCart, position: "top-[0%] left-[10%]", delay: "0s", duration: "3s", color: "orange" },
      { icon: Search, position: "top-[0%] right-[10%]", delay: "0.5s", duration: "3.5s", color: "mint" },
      { icon: Package, position: "top-[30%] -left-[6%]", delay: "1s", duration: "4s", color: "primary" },
      { icon: CreditCard, position: "top-[60%] -left-[4%]", delay: "1.5s", duration: "3.2s", color: "mint" },
      { icon: Sparkles, position: "bottom-[3%] left-[15%]", delay: "0.7s", duration: "3.8s", color: "orange" },
      { icon: TrendingUp, position: "top-[25%] -right-[6%]", delay: "2s", duration: "3.6s", color: "primary" },
    ]}
    kpis={[
      { icon: ShoppingCart, labelKey: "kpiConsultations", valueKey: "kpiConsultationsValue", color: "text-chathero-mint" },
      { icon: CreditCard, labelKey: "kpiCart", valueKey: "kpiCartValue", color: "text-chathero-orange" },
      { icon: TrendingUp, labelKey: "kpiConversion", valueKey: "kpiConversionValue", color: "text-primary" },
    ]}
    barColor="bg-chathero-orange/60"
  />
);

export default EcommerceHero;
